import { Component, ElementRef, ViewChild } from '@angular/core';
import * as XLSX from 'xlsx';
import { DashboardChartVehicle } from '../dashboard-modals.models';

declare let $: any;

@Component({
  selector: 'app-dashboard-chart-vehicles-modal',
  templateUrl: './chart-vehicles-modal.component.html',
})
export class DashboardChartVehiclesModalComponent {
  @ViewChild('exportTable') private exportTable!: ElementRef<HTMLTableElement>;

  vehicles: DashboardChartVehicle[] = [];
  private fileName = 'ExcelSheet.xlsx';

  open(vehicles: DashboardChartVehicle[], fileName: string): void {
    this.vehicles = vehicles;
    this.fileName = fileName;
    $('#CarStatusModal').modal('show');
  }

  exportExcel(): void {
    const worksheet = XLSX.utils.table_to_sheet(this.exportTable.nativeElement);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
    XLSX.writeFile(workbook, this.fileName);
  }
}
